import { createActions } from 'redux-actions';
import { v1 as uuid } from 'uuid';

import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from './consts';

const defaultNotification = (content, config) =>
	addNotification({
		content,
		...config,
	});

const successNotification = (content, config) =>
	addNotification({
		success: true,
		content,
		...config,
	});

const warningNotification = (content, config) =>
	addNotification({
		warning: true,
		content,
		...config,
	});

const dangerNotification = (content, config) =>
	addNotification({
		danger: true,
		content,
		...config,
	});

const { addNotification, removeNotification } = createActions({
	[ADD_NOTIFICATION]: (notification) => {
		return {
			...notification,
			id: uuid(),
		};
	},
	[REMOVE_NOTIFICATION]: (id) => id,
});

export { defaultNotification, successNotification, warningNotification, dangerNotification, removeNotification };
